module.exports = __webpack_public_path__ + "img/2.40e93957.jpg";